import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch3, fetch4 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useFetchInvoiceData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  return useQuery({
    queryKey: ["invoiceData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/invoiceManagements?page=${page}&limit=${limit}&searchFor=${encodeURIComponent(
          searchFor || ""
        )}`,
        "get"
      );

      if (!res || !res.data) {
        return { invoices: [], total: 0, page: 1, totalPages: 1 };
      }

      return res.data;
    },
  });
};

export const useInvoiceCreateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/invoiceManagements`,
        payload
      );

      if (!res?.success) {
        throw res;
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("Invoice created successfully:", data);
      queryClient.invalidateQueries({ queryKey: ["invoiceData"] });
    },
    onError: (error: any) => {
      console.error("Invoice create request failed:", error);
    },
  });
};
